export default function capitalizeBusinessName(str: string) {
  return str ? str.substring(0, 2).toUpperCase() : "";
}
